module.exports = __webpack_public_path__ + "static/media/greenCheck.3014829e.svg";